// extracted by mini-css-extract-plugin
export default {"landing__outer":"landing_landing__outer__+bCFz","langing__gap":"landing_langing__gap__PduWE"};